import { Component, HostListener, ViewChild, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/internal/Subject';
import { UiModalComponent } from './shared/components/ui-modal/ui-modal.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  private router = inject(Router);
  private Location = inject(Location);

  title = 'userweb-redesign';
  public invoiceBoard: any;

  private userInactive = new Subject<any>();
  @ViewChild('sessionExpiredInActivity') inActivityExpire!: UiModalComponent;

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(_event: any) {
    window.scrollTo(0, 0);
  }

  routerEvents: any;
  constructor() {
    this.routerEvents = this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.getRedirectUrl(event.url);
        }
      }
    )
    const routerUrl: any = this.Location.path()
    const _routerPath: any = routerUrl?.split('/');
    sessionStorage?.setItem('headerFacilityId', '95');
  }

  private getRedirectUrl(url: string): void {
    let newUrl;
    if (url?.includes('bookappt')) {
      newUrl = url?.replace('bookappt', 'scheduleappt');
      this.router?.navigate([newUrl]);
      return;
    }
    if (url?.includes('patientOutreach')) {
      newUrl = url?.replace('patientOutreach', 'outReach');
      this.router?.navigate([newUrl]);
      return;
    }
    if (url?.includes('paymentBill')) {
      newUrl = url?.replace('paymentBill', 'payYourBill');
      this.router?.navigate([newUrl]);
      return;
    }
    if (url?.includes('teliHealth')) {
      newUrl = url?.replace('teliHealth', 'teleHealth');
      this.router?.navigate([newUrl]);
      return;
    }
  }

}
